module.exports = __webpack_public_path__ + "static/favicon-f59c42614a0e7d3ca3a514ddf1bcd712.ico";